import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import { ElementTiptapPlugin } from 'element-tiptap'
import 'element-tiptap/lib/index.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import VueExpandableImage from 'vue-expandable-image'
import VueLocalStorage from 'vue-localstorage'
import VueMomentJalaali from 'vue-moment-jalaali'
import useAxios from '@/composables/useAxios'
import { i18n } from '@/plugins/i18n'
import App from './App.vue'
import './plugins/acl'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

Vue.use(ElementUI)
Vue.use(ElementTiptapPlugin, {
  dir: 'rtl',
})

// Enable devtoo
Vue.config.devtools = true

Vue.config.productionTip = false

const moment = require('moment-jalaali')

moment.loadPersian({ usePersianDigits: true })

Vue.use(VueLocalStorage, {
  name: 'ls',
})
Vue.use(VueMomentJalaali)
Vue.use(Croppa)

Vue.use(VueExpandableImage)

const playSound = () => {
  const audio = new Audio(require('@/assets/to-the-point-568.mp3'))
  audio.play().catch(() => {})
}

const auth = {
  loggedIn() {
    return store.state.token !== '' || localStorage.getItem('token') !== null
  },
}

const getNotifications = () => {
  if (!auth.loggedIn()) return

  const requestToken = localStorage.getItem('token')
  useAxios().axiosPost(store.getters.routeApi('get_notifications'))
    .then(response => {
      if (!response || !response.status || requestToken !== localStorage.getItem('token')) return
      const notices = (response.conditional_return_notifications || [])
        .filter(notice => !store.state.readConditionalReturnNotificationIds.includes(notice.id))
      const previous = store.state.notifications.conditional_return_notifications || []
      const hasNewNotice = notices.some(notice => !previous.some(old => old.id === notice.id))
      const enabled = store.state.appConfig.app.isActiveNotifications === 'enable'
      store.commit('storeNotifications', {
        tickets: response.tickets || 0,
        auths: response.auths || 0,
        manual_send_bills: response.manual_send_bills || 0,
        conditional_return_notifications: notices,
        silent: !enabled,
      })
      if (enabled && (response.tickets > 0 || response.auths > 0 || response.manual_send_bills > 0 || hasNewNotice)) {
        playSound()
      }

      store.commit('storeInfo', {
        dollar: response.goal_dollar_price,
        percent: response.main_percent,
      })
    })
    .catch(() => {
    })
}

window.setInterval(getNotifications, 240000)
store.watch(state => state.token, token => { if (token) getNotifications() })
getNotifications()

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
